import { ChartArea } from "chart.js";

const createGradient = (ctx: CanvasRenderingContext2D, area: ChartArea, startColor: string, endColor: string) => {
  if (!area) {
    return;
  }
  const gradient = ctx.createLinearGradient(area.left, 0, area.right, 0);
  gradient.addColorStop(0, startColor);
  gradient.addColorStop(1, endColor);
  return gradient;
};

export default createGradient;